import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';

const statusColorMap = {
  // Sale statuses
  scheduled: { color: 'info', label: 'Scheduled' },
  'in-progress': { color: 'warning', label: 'In Progress' },
  completed: { color: 'success', label: 'Completed' },
  cancelled: { color: 'error', label: 'Cancelled' },

  // Lead statuses
  new: { color: 'info', label: 'New' },
  contacted: { color: 'primary', label: 'Contacted' },
  qualified: { color: 'success', label: 'Qualified' },
  converted: { color: 'success', label: 'Converted' },
  lost: { color: 'error', label: 'Lost' },

  // Invoice statuses
  draft: { color: 'default', label: 'Draft' },
  sent: { color: 'info', label: 'Sent' },
  paid: { color: 'success', label: 'Paid' },
  partially_paid: { color: 'warning', label: 'Partially Paid' },
  overdue: { color: 'error', label: 'Overdue' },
  voided: { color: 'default', label: 'Voided' },

  // Inventory statuses
  available: { color: 'success', label: 'Available' },
  sold: { color: 'default', label: 'Sold' },
  reserved: { color: 'warning', label: 'Reserved' },
  damaged: { color: 'error', label: 'Damaged' },

  // Generic statuses
  active: { color: 'success', label: 'Active' },
  inactive: { color: 'default', label: 'Inactive' },
  pending: { color: 'warning', label: 'Pending' },
  approved: { color: 'success', label: 'Approved' },
  rejected: { color: 'error', label: 'Rejected' },
};

const StatusChip = ({ status, size, variant, customLabel, customColor }) => {
  const statusConfig = statusColorMap[status?.toLowerCase()] || {
    color: 'default',
    label: status,
  };

  const displayLabel = customLabel || statusConfig.label;
  const chipColor = customColor || statusConfig.color;

  return (
    <Chip
      label={displayLabel}
      color={chipColor}
      size={size}
      variant={variant}
      sx={{
        fontWeight: 500,
        textTransform: 'capitalize',
      }}
    />
  );
};

StatusChip.propTypes = {
  status: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium']),
  variant: PropTypes.oneOf(['filled', 'outlined']),
  customLabel: PropTypes.string,
  customColor: PropTypes.oneOf([
    'default',
    'primary',
    'secondary',
    'error',
    'info',
    'success',
    'warning',
  ]),
};

StatusChip.defaultProps = {
  size: 'small',
  variant: 'filled',
  customLabel: null,
  customColor: null,
};

export default StatusChip;
